"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/* eslint-disable @atg/css-rtl-support */

/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var Dialog = {
  styles: function styles(theme) {
    return {
      bottom: {
        borderRadius: [theme.spacing.base * 2, theme.spacing.base * 2, 0, 0],
        borderColor: theme.colors.baseContrast015,
        borderStyle: "solid",
        borderWidth: [1, 1, 0, 1],
        paddingTop: 0,
        "&::before": {
          content: '""',
          display: "flex",
          borderRadius: 4,
          height: theme.spacing.base / 2,
          width: theme.spacing.base * 4,
          margin: [theme.spacing.base * 2.25, "auto"],
          backgroundColor: theme.colors.baseContrast030
        }
      }
    };
  }
};
var _default = exports.default = Dialog;